import { NgModule } from '@angular/core';
import { NgxsModule } from '@ngxs/store';

import { AccountStoreState } from './store';

@NgModule({
  imports: [
    NgxsModule.forFeature([ AccountStoreState ])
  ]
})
export class AccountWebSharedStoreModule {}
